import styled from 'styled-components';

// One labeled property "card" — visually groups the label with its control
// so the Edits panel reads as a tidy stack of fields rather than a jumble of
// disconnected labels and inputs.
//
// The descendant rule strips the wide margin-top that Widget/Input/styles.ts
// Base.Base adds to inputs (NumberInput, ColorInput, etc.) — that margin is
// designed for inputs that sit directly under a free-floating label. Inside a
// Field, our own gap controls the label-to-input spacing, so the input's own
// top margin would double-space.
export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 8px 10px;
	background: ${({ theme }) => theme.gray[100]};
	border-radius: 6px;

	& > * {
		margin-top: 0;
	}
`;

// Top row holds the label and an optional right-side accessory (e.g. a
// "Per side" toggle in PaddingEditControl).
export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`;

export const Label = styled.div`
	font-size: 11px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[600]};
	letter-spacing: 0.01em;
`;

export const Aside = styled.span`
	font-size: 11px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[600]};
	font-style: italic;
	margin-left: 6px;
`;
